import { Box, Button } from '@mui/material'; 
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface IProps {
    bundle: string;
}

const useStyles =  () => ({
    root: {
        display: 'flex !important',
        flexDirection: 'column !important',
        justifyContent: 'center !important',
        alignItems: 'center !important',
        width: '100% !important',
        height: '100vh !important'
    }
});

export const NotFound = (props: IProps) => {
    const classes = useStyles();
    const navigate = useNavigate();

    const goBack = () => {
        // Try to go back in history
        if (window.history.length > 2) {
            navigate(-1);
        } else {
            // Otherwise go to the bundle root
            navigate(`/${props.bundle}`, { replace: true });
        }
    }

    return(
        <Box sx={classes.root}>
            <h1>404</h1>
            <h3>Ooops nothing here...</h3>
            <Button 
                onClick={goBack}
                color='inherit'
            >
                Go Back
            </Button>
        </Box>
    )
}